import React from 'react';

import { faBuilding, faCircleUser, faHandshake } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';

import { Badge } from '@buildoutinc/blueprint-react/ui/Badge';
import { findMatchingCurrentParent } from 'bundles/crm/parent_helpers';
import type { Parent } from 'bundles/crm/types';
import type { Task } from '../../types';


interface Props {
  currentParent?: Parent;
  modalOpen?: boolean;
  task: Task;
}

const PARENT_ICONS: Record<string, IconDefinition> = {
  'Backoffice::Contact': faCircleUser,
  'Apex::Deal': faHandshake,
  'Project': faBuilding,
  'Listing': faBuilding,
  'Research::Property': faBuilding,
};

export default function Parent({ currentParent, modalOpen, task }: Props) {
  if (!task.parent || findMatchingCurrentParent(task, currentParent)) {
    return null;
  }

  return (
    <div className="d-flex align-items-center gap-1 text-truncate" style={{ minWidth: 0 }}>
      <FontAwesomeIcon className="text-muted" icon={PARENT_ICONS[task.parent.type]} size="sm"/>
      {/* TODO: Always have link when we convert from offcanvas to modal (i.e. remove the modalOpen check */}
      {modalOpen ?
        <div className="text-accent text-truncate fw-semibold">{task.parent.label}</div> :
        <a className="text-truncate fw-semibold" href={task.parent.path} onClick={e => e.stopPropagation()}>{task.parent.label}</a>
      }
    </div>
  );
}
